/**
 * InboxOutboxIcon/index.js
 * desc: inbox-outbox icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const InboxOutboxIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="inbox-outbox icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.inboxOutbox.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path d="M16 0H2C.9 0 0 .9 0 2v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 6h-4c0 1.62-1.38 3-3 3S6 7.62 6 6H2V2h14v4zm2 7h-6c0 1.66-1.34 3-3 3s-3-1.34-3-3H0v3c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-3z" /></svg>
    </IconButton>
);


export default InboxOutboxIcon;
